import { FeatureFlag } from '@cbo/shared-library';
import { PosProvider } from '@cbo/shared-library/types/posProvider';
import { useFeatureFlag } from './useFeatureFlag';
import { usePosQuery } from '../../admin/requests/queries';

/**
 * Custom hook to determine if the current organization is a CFC (Aloha POS) organization.
 *
 * @param enabled - Whether to enable the POS query (defaults to true)
 * @returns Object containing isCfcOrg boolean and loading state
 */
const useCfcOrg = (enabled = true) => {
  const enableCfcExperience = useFeatureFlag(FeatureFlag.enableCFCExperience);
  const { data: posData, isLoading: isPosDataLoading } = usePosQuery(enabled && enableCfcExperience);

  const isCfcOrg = enableCfcExperience && posData?.posProvider === PosProvider.ALOHA;
  const isLoading = enableCfcExperience ? isPosDataLoading : false;

  return { isCfcOrg, isPosDataLoading: isLoading };
};

export default useCfcOrg;
